import Component from "./MasavExportsArchive"
import { Actions } from "../actions"
import { connect } from "react-redux"
import { Selectors } from "../../modules/masavExports"

export default connect((state) => ({
    masavExports: Selectors.getMasavExports(state),
    masavExportsCount: Selectors.getMasavExportsCount(state),
    loading: Selectors.getLoading(state),
}), {
    onMount: Actions.MASAV_EXPORTS_PAGE_MOUNTED,
})(Component)

